export const marginScrollService = (
	{ current: scrollBody }: React.RefObject<HTMLUListElement>,
	{ current: fixedBody }: React.RefObject<HTMLUListElement>,
	{ current: scrollHead }: React.RefObject<HTMLUListElement>
) => {
	if (fixedBody) {
		fixedBody.scrollTop = scrollBody?.scrollTop || 0;
	}

	if (scrollHead) {
		scrollHead.scrollLeft = scrollBody?.scrollLeft || 0;
	}
};
